/**
 * AUTO-GENERATED by scripts/generate-tokens.mjs
 * Source: figma-variables.json
 * Do not edit manually — re-run: npm run tokens
 */

// ---------------------------------------------------------------------------
// Palette Colors (Tailwind 50-950 scale)
// ---------------------------------------------------------------------------
export const palette = {
  "primary": {
    "50": "#ede6f9",
    "100": "#dccef3",
    "200": "#b89ce6",
    "300": "#ab8be2",
    "350": "#9C7CE8",
    "400": "#9e7ade",
    "500": "#845ad4",
    "600": "#7751c0",
    "700": "#6947ab",
    "800": "#5c3f96",
    "900": "#4f3680",
    "950": "#281b40",
    "DEFAULT": "#845ad4",
    "contrast-text": "#ffffff"
  },
  "secondary": {
    "50": "#fdf1e9",
    "100": "#fae3d3",
    "200": "#f5c7a6",
    "300": "#f4b992",
    "400": "#f2ab7d",
    "500": "#ee8e4d",
    "600": "#d78145",
    "700": "#bf733d",
    "800": "#a76537",
    "900": "#8f5730",
    "950": "#482c18",
    "DEFAULT": "#ee8e4d",
    "contrast-text": "#ffffff"
  },
  "info": {
    "50": "#f2fefd",
    "100": "#e4fefa",
    "200": "#c9fcf5",
    "300": "#95f7f4",
    "400": "#61f2f2",
    "500": "#00b8d9",
    "600": "#0092bb",
    "700": "#006b9c",
    "800": "#005283",
    "900": "#003869",
    "950": "#001c35",
    "DEFAULT": "#00b8d9",
    "contrast-text": "#ffffff"
  },
  "success": {
    "50": "#e9f1e8",
    "100": "#d3e3d0",
    "200": "#a6c7a1",
    "300": "#98c18e",
    "400": "#8aba7a",
    "500": "#6a994e",
    "600": "#5f8a46",
    "700": "#547a3d",
    "800": "#4a6b36",
    "900": "#405c2e",
    "950": "#202e17",
    "DEFAULT": "#6a994e",
    "contrast-text": "#ffffff"
  },
  "warning": {
    "50": "#fffdf2",
    "100": "#fffae6",
    "200": "#fff5cc",
    "300": "#ffe699",
    "400": "#ffd666",
    "500": "#ffab00",
    "600": "#dc8d00",
    "700": "#b86e00",
    "800": "#995700",
    "900": "#7a4000",
    "950": "#3d2000",
    "DEFAULT": "#ffab00",
    "contrast-text": "#47454d"
  },
  "error": {
    "50": "#fff9f5",
    "100": "#fff4eb",
    "200": "#ffe8d6",
    "300": "#ffcaac",
    "400": "#ffab82",
    "500": "#ff5730",
    "600": "#dc3a24",
    "700": "#b81c17",
    "800": "#991317",
    "900": "#7a0a17",
    "950": "#3d050c",
    "DEFAULT": "#ff5730",
    "contrast-text": "#ffffff"
  },
  "grey": {
    "50": "#fafafa",
    "100": "#f2f2f5",
    "200": "#e6e6eb",
    "300": "#d9d9de",
    "400": "#c9c7d1",
    "500": "#bdbcc9",
    "600": "#9694a3",
    "700": "#706e78",
    "800": "#47454d",
    "900": "#2b292e",
    "950": "#161517",
    "DEFAULT": "#bdbcc9"
  },
  "black": "#26252d",
  "white": "#ffffff"
} as const;

// ---------------------------------------------------------------------------
// Semantic Theme Colors (CSS RGB triplets for use with rgb() / rgba())
// ---------------------------------------------------------------------------
export const semanticLight = {
  "text-primary": "71 69 77",
  "text-secondary": "150 148 163",
  "text-disabled": "189 188 201",
  "action-active": "150 148 163",
  "action-hover": "189 189 201",
  "action-selected": "189 189 201",
  "action-focus": "189 189 201",
  "action-disabled": "189 189 201",
  "action-disabled-bgcolor": "189 189 201",
  "background-default": "255 255 255",
  "background-paper": "255 255 255",
  "background-neutral": "230 230 235",
  "components-divider": "189 189 201",
  "components-input-outlined": "189 189 201",
  "components-paper-outlined": "189 189 201",
  "components-table-border": "189 189 201",
  "components-table-row-hover": "189 189 201",
  "components-table-row-selected": "132 90 212",
  "components-tooltip-color": "255 255 255",
  "components-tooltip-bgcolor": "71 69 77",
  "components-button-outlined": "189 189 201"
} as const;

export const semanticDark = {
  "text-primary": "255 255 255",
  "text-secondary": "189 188 201",
  "text-disabled": "150 148 163",
  "action-active": "189 188 201",
  "action-hover": "189 189 201",
  "action-selected": "189 189 201",
  "action-focus": "189 189 201",
  "action-disabled": "189 189 201",
  "action-disabled-bgcolor": "189 189 201",
  "background-default": "28 28 28",
  "background-paper": "38 38 41",
  "background-neutral": "41 51 61",
  "components-divider": "189 189 201",
  "components-input-outlined": "189 189 201",
  "components-paper-outlined": "189 189 201",
  "components-table-border": "189 189 201",
  "components-table-row-hover": "189 189 201",
  "components-table-row-selected": "132 90 212",
  "components-tooltip-color": "255 255 255",
  "components-tooltip-bgcolor": "112 110 120",
  "components-button-outlined": "189 189 201"
} as const;

// ---------------------------------------------------------------------------
// Spacing (8px base unit from Figma)
// ---------------------------------------------------------------------------
export const spacing = {
  "1": "4px",
  "2": "8px",
  "3": "12px",
  "4": "16px",
  "5": "20px",
  "6": "24px",
  "7": "28px",
  "8": "32px",
  "9": "36px",
  "10": "40px",
  "11": "44px",
  "12": "48px",
  "13": "52px",
  "14": "56px",
  "15": "60px",
  "16": "64px",
  "17": "68px",
  "18": "72px",
  "19": "76px",
  "20": "80px",
  "2px": "2px",
  "0.5": "2px",
  "0.75": "3px",
  "1.25": "5px",
  "1.5": "6px",
  "1.75": "7px",
  "2.5": "10px"
} as const;

// ---------------------------------------------------------------------------
// Border Radius
// ---------------------------------------------------------------------------
export const radius = {
  "1": "4px",
  "2": "8px",
  "3": "12px",
  "4": "16px",
  "5": "20px",
  "6": "24px",
  "7": "28px",
  "8": "32px",
  "9": "36px",
  "10": "40px",
  "1px": "1px",
  "2px": "2px",
  "0.5": "2px",
  "0.75": "3px",
  "1.25": "5px",
  "1.5": "6px",
  "1.75": "7px",
  "2.5": "10px",
  "50%": "500px"
} as const;

// ---------------------------------------------------------------------------
// Shadows (z-elevation system)
// ---------------------------------------------------------------------------
export const shadows = {
  "z1": "0px 1px 2px 0px #bdbdc933",
  "z4": "0px 4px 8px 0px #bdbdc933",
  "z8": "0px 8px 16px 0px #bdbdc933",
  "z12": "0px 12px 24px -4px #bdbdc933",
  "z16": "0px 16px 32px -4px #bdbdc933",
  "z20": "0px 20px 40px -4px #bdbdc933",
  "z24": "0px 24px 48px 0px #bdbdc933"
} as const;

// ---------------------------------------------------------------------------
// Typography — fontSize config for Tailwind
// Each entry: [fontSize, { lineHeight, fontWeight, letterSpacing? }]
// ---------------------------------------------------------------------------
export const fontSizeConfig = {
  "hero": [
    "72px",
    {
      "lineHeight": "90px",
      "fontWeight": "800"
    }
  ],
  "h1": [
    "64px",
    {
      "lineHeight": "80px",
      "fontWeight": "800"
    }
  ],
  "h2": [
    "48px",
    {
      "lineHeight": "64px",
      "fontWeight": "800"
    }
  ],
  "h3": [
    "32px",
    {
      "lineHeight": "48px",
      "fontWeight": "700"
    }
  ],
  "h4": [
    "24px",
    {
      "lineHeight": "36px",
      "fontWeight": "700"
    }
  ],
  "h5": [
    "20px",
    {
      "lineHeight": "30px",
      "fontWeight": "700"
    }
  ],
  "h6": [
    "18px",
    {
      "lineHeight": "28px",
      "fontWeight": "600"
    }
  ],
  "subtitle1": [
    "16px",
    {
      "lineHeight": "24px",
      "fontWeight": "600"
    }
  ],
  "subtitle2": [
    "14px",
    {
      "lineHeight": "22px",
      "fontWeight": "600"
    }
  ],
  "body1": [
    "16px",
    {
      "lineHeight": "24px",
      "fontWeight": "400"
    }
  ],
  "body2": [
    "14px",
    {
      "lineHeight": "22px",
      "fontWeight": "400"
    }
  ],
  "caption": [
    "12px",
    {
      "lineHeight": "18px",
      "fontWeight": "400"
    }
  ],
  "overline": [
    "12px",
    {
      "lineHeight": "18px",
      "fontWeight": "700"
    }
  ]
} as const;

// ---------------------------------------------------------------------------
// Font Family
// ---------------------------------------------------------------------------
export const fontFamily = 'Poppins' as const;

// ---------------------------------------------------------------------------
// Desktop / Mobile typography raw data (for advanced usage)
// ---------------------------------------------------------------------------
export const desktopTypography = {
  "family": {
    "primary": "Poppins",
    "secondary": "Poppins"
  },
  "weight": {
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800
  },
  "hero": {
    "family": "Poppins",
    "size": 72,
    "weight": 800,
    "line-height": 90,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h1": {
    "family": "Poppins",
    "size": 64,
    "weight": 800,
    "line-height": 80,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h2": {
    "family": "Poppins",
    "size": 48,
    "weight": 800,
    "line-height": 64,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h3": {
    "family": "Poppins",
    "size": 32,
    "weight": 700,
    "line-height": 48,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h4": {
    "family": "Poppins",
    "size": 24,
    "weight": 700,
    "line-height": 36,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h5": {
    "family": "Poppins",
    "size": 20,
    "weight": 700,
    "line-height": 30,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h6": {
    "family": "Poppins",
    "size": 18,
    "weight": 600,
    "line-height": 28,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "subtitle1": {
    "family": "Poppins",
    "size": 16,
    "weight": 600,
    "line-height": 24,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "subtitle2": {
    "family": "Poppins",
    "size": 14,
    "weight": 600,
    "line-height": 22,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "body1": {
    "family": "Poppins",
    "size": 16,
    "weight": 400,
    "line-height": 24,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "body2": {
    "family": "Poppins",
    "size": 14,
    "weight": 400,
    "line-height": 22,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "caption": {
    "family": "Poppins",
    "size": 12,
    "weight": 400,
    "line-height": 18,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "overline": {
    "family": "Poppins",
    "size": 12,
    "weight": 700,
    "line-height": 18,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  }
} as const;
export const mobileTypography = {
  "family": {
    "primary": "Poppins",
    "secondary": "Poppins"
  },
  "weight": {
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800
  },
  "hero": {
    "family": "Poppins",
    "size": 40,
    "weight": 800,
    "line-height": 50,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h1": {
    "family": "Poppins",
    "size": 40,
    "weight": 800,
    "line-height": 50,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h2": {
    "family": "Poppins",
    "size": 32,
    "weight": 800,
    "line-height": 42.67,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h3": {
    "family": "Poppins",
    "size": 24,
    "weight": 700,
    "line-height": 36,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h4": {
    "family": "Poppins",
    "size": 20,
    "weight": 700,
    "line-height": 30,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h5": {
    "family": "Poppins",
    "size": 18,
    "weight": 700,
    "line-height": 27,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "h6": {
    "family": "Poppins",
    "size": 17,
    "weight": 600,
    "line-height": 26.44,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "subtitle1": {
    "family": "Poppins",
    "size": 16,
    "weight": 600,
    "line-height": 24,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "subtitle2": {
    "family": "Poppins",
    "size": 14,
    "weight": 600,
    "line-height": 22,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "body1": {
    "family": "Poppins",
    "size": 16,
    "weight": 400,
    "line-height": 24,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "body2": {
    "family": "Poppins",
    "size": 14,
    "weight": 400,
    "line-height": 22,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "caption": {
    "family": "Poppins",
    "size": 12,
    "weight": 400,
    "line-height": 18,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  },
  "overline": {
    "family": "Poppins",
    "size": 12,
    "weight": 700,
    "line-height": 18,
    "letter-spacing": 0,
    "paragraph-spacing": 0
  }
} as const;
